import common from './common-educabot'

export default {
  ...common.button,
  color: `#9B00AF`,
  '::before': {
    display: `none`
  },
  '::after': {
    ...common.button['::after'],
    width: '115%',
    bg: `white`,
    border: '0.5px solid',
    borderColor: `#9B00AF`
  }
}